export enum ETypeHoliday {
  School = "school",
  Public = "public",
}

export const typeList = [
  { id: ETypeHoliday.School, name: "School Holiday" },
  { id: ETypeHoliday.Public, name: "Public Holiday" },
];
